// extracted by mini-css-extract-plugin
module.exports = {"root":"_bc84a7","disabled":"_d7d34f","star":"_83fd77","rating":"_a5a9a8"};